import { BaseIcon, BaseIconProps } from '../BaseIcon';

export type SpeciFinderIconProps = Omit<BaseIconProps, 'children'>;

export const SpeciFinderIcon = ({ ...props }: SpeciFinderIconProps) => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" hasLegacyStrokeStyles={true} {...props}>
    <g strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path d="M14.9998 7.39016V8.00349C14.999 9.4411 14.5335 10.8399 13.6727 11.9914C12.812 13.1428 11.602 13.9851 10.2234 14.3928C8.84479 14.8004 7.37134 14.7514 6.02282 14.2532C4.67429 13.755 3.52294 12.8342 2.74048 11.6282C1.95801 10.4222 1.58636 8.99553 1.68096 7.56103C1.77555 6.12653 2.33131 4.76104 3.26536 3.66821C4.19941 2.57537 5.46169 1.81375 6.86396 1.49692C8.26623 1.1801 9.73335 1.32505 11.0465 1.91016" />
      <path d="M14.9999 2.6709L8.33325 9.34423L6.33325 7.34423" />
    </g>
  </BaseIcon>
);

SpeciFinderIcon.displayName = 'SpeciFinderIcon';
